import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { fetchTemplates } from '../../api/templatesApi';
import { listFlows } from '../../api/flowsApi';
import { toStarter, toSavedTask, sortSavedTasks, toRecentCanvases } from './homeData';

export function filterStarters(templates, profile) {
  const list = templates || [];
  if (!profile || !profile.group_function) return list;
  const slice = list.filter(
    (t) => t.domain === profile.group_function && (!profile.role || t.role === profile.role)
  );
  // Legacy sets predate exact role labels: fall back to the domain match.
  if (slice.length > 0) return slice;
  return list.filter((t) => t.domain === profile.group_function);
}

const settle = (promise, fallback) => promise.catch(() => fallback);

export function useHomeData() {
  const [state, setState] = useState({
    loading: true, profile: null, starters: [], tasks: [], canvases: [],
  });
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    (async () => {
      const [profile, starters, templates, flows] = await Promise.all([
        settle(axios.get('/user/profile').then((r) => r.data), null),
        settle(fetchTemplates(null, null, 'starter'), []),
        settle(fetchTemplates(null, false), []),
        settle(listFlows(), []),
      ]);
      if (!mounted.current) return;
      setState({
        loading: false,
        profile,
        starters: filterStarters(starters, profile).map(toStarter),
        tasks: sortSavedTasks(
          (templates || []).filter((t) => t.template_class !== 'starter').map(toSavedTask)
        ),
        canvases: toRecentCanvases(flows),
      });
    })();
    return () => { mounted.current = false; };
  }, []);

  const refreshStarters = useCallback(async () => {
    const starters = await settle(fetchTemplates(null, null, 'starter'), []);
    if (mounted.current) {
      setState((s) => ({ ...s, starters: filterStarters(starters, s.profile).map(toStarter) }));
    }
  }, []);

  return { ...state, refreshStarters };
}
